export function loadDocuments(category_id = 0) {
    this.preloader = true;
    typeof category_id === 'object' ? category_id = 0 : category_id = category_id;
    var document_url = this.formUrl + 'search_select=' + category_id + '&searchText=' + this.searchText;
    this.axiosGet(document_url)
        .then((res) => {
            // this.children = res.data;
            // console.log(res.data);
            this.preloader = false;
            // console.log("response documents", res.data);
            this.parentEl = res.data.filter(da => {
                return da.get_forms.parent_id == null;
            })
            this.childEl = res.data.filter(da => {
                return da.get_forms.parent_id !== null;
            })

            this.parentEl = this.parentEl.map(pa => {
                return {
                    form_id: pa.form_id,
                    company_id: pa.company_id,
                    label: pa.get_forms.name,
                    owner_id: pa.get_forms.owner_id,
                    is_file_folder: pa.get_forms.is_file_folder,
                    category_name: pa.get_forms.form_category ? pa.get_forms.form_category.title : '', //Without Category
                    updated_at: moment(pa.updated_at).format('YYYY-MM-DD'),
                    // children:[]
                }
            }),

                this.children = res.data.map(pa => {
                    return {
                        id: pa.form_id,
                        company_id: pa.company_id,
                        label: pa.get_forms.name,
                        owner_id: pa.get_forms.owner_id,
                        is_file_folder: pa.get_forms.is_file_folder,
                        parent_id: pa.get_forms.parent_id,
                        category_name: pa.get_forms.form_category ? pa.get_forms.form_category.title : '', //Without Category
                        updated_at: moment(pa.updated_at).format('YYYY-MM-DD'),
                        nodes: null,
                        responseOnly: pa.response_only,
                    }
                })
            //  this.tree = {...this.tree, nodes : this.children};
            //  console.log("tree", this.tree);
            this.openSubList();
            //  console.log("parent element", this.parentEl);
            this.documents = this.parentEl;
            //  console.log("parent element", this.documents);
            // this.links = res.data.links;
            // this.next_page_url = res.next_page_url;
            // this.prev_page_url = res.prev_page_url;

        })
        .catch((res) => {
            console.error("Directory Issue: ", res);
        })
        .finally(() => {
            this.preloader = false;

        });
}

export function unFlatten(arr) {
    var tree = [],
        mappedArr = {},
        arrElem,
        mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.id] = arrElem;
        mappedArr[arrElem.id]['nodes'] = [];
    }

    // Iterate over the mapped array and create the tree structure.
    for (var id in mappedArr) {
        if (mappedArr.hasOwnProperty(id)) {
            mappedElem = mappedArr[id];
            if (mappedElem.parent_id && mappedArr[mappedElem['parent_id']]) {
                mappedArr[mappedElem['parent_id']]['nodes'].push(mappedElem);
            } else {
                tree.push(mappedElem);
            }
        }
    }

    // Create an Intl.Collator instance for locale-sensitive string comparison
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

    // Sort each level of the tree by label
    function sortTree(nodes) {
        nodes = nodes.filter(node => !node?.responseOnly);
        nodes.sort((a, b) => collator.compare(a.label, b.label));
        nodes.forEach(node => {
            if (node.is_file_folder === 'folder') {
                node.label += ` (${node.nodes.length})`;
            }
            if (node.nodes && node.nodes.length > 0) {
                node.nodes = sortTree(node.nodes);
            }
        });
        return nodes;
    }

    // Apply sorting to the tree nodes
    tree = sortTree(tree);

    return tree;
}
export function createListTree(data02){
    this.childEl =  this.childEl.map(res => {
        return data02.map(res02 => {
            return res02.filter(data => {
                return data.get_forms.parent_id == res.form_id;
            });
        })
    })
    // console.log("data03 ==>", data03)
}